import React, { useMemo, useRef, useState } from "react";
import PropTypes from "prop-types";
import ControlledInput from "./ControlledInput";
import { Button, Paper } from "@mui/material";
import { ChromePicker } from "react-color";
import TranslationWrapper from "../TranslationWrapper/TranslationWrapper";

function ColorPickerV2(props) {
  const [open, setOpen] = useState(false);
  const [color, setColor] = useState("");
  const inputRef = React.useRef(null);
  const canBlurRef = useRef(true);

  const paper = useMemo(() => {
    return (
      open && (
        <Paper
          onMouseEnter={() => {
            canBlurRef.current = false;
          }}
          onMouseLeave={() => {
            canBlurRef.current = true;
          }}
          style={{
            position: "absolute",
            zIndex: 10,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: 8,
          }}
        >
          <ChromePicker
            color={color ?? ""}
            disableAlpha={props.disableAlpha}
            onChange={(color) => {
              let alpha = Math.round(color.rgb.a * 255);

              setColor(color.hex + alpha.toString(16));
            }}
            styles={{ default: { picker: { boxShadow: "none" } } }}
          />
          <Button
            color={"primary"}
            onClick={() => {
              props.onChange(color);

              canBlurRef.current = true;
              inputRef.current.blur();
            }}
            variant={"contained"}
          >
            <TranslationWrapper tDefault={"Aanpassen"} tKey={"global.colerpicker"} />
          </Button>
        </Paper>
      )
    );
  }, [open, props.onChange, color]);

  return [
    paper,
    <ControlledInput
      InputProps={{
        inputRef: inputRef,
        onBlur: () => {
          if (canBlurRef.current) {
            setColor(props.value);
            setOpen(false);
            inputRef.current.blur();
          } else {
            inputRef.current.focus();
          }
        },

        startAdornment: (
          <Button
            onClick={() => {
              setOpen(true);
              inputRef.current.focus();
            }}
            style={{
              backgroundColor: props.value,
              marginRight: 16,
              padding: "8px 0",
            }}
            variant={"contained"}
            // disabled={true}
            size={"small"}
          />
        ),
      }}
      controlled={false}
      key={props.value}
      nullable={props.nullable}
      onHandleValue={(value) => {
        setColor(value);
        props.onChange(value ? String(value) : value);
        const change = new Event("change", String(value));
        inputRef.current?.dispatchEvent(change);
      }}
      value={props.value}
    />,
  ];
}

ColorPickerV2.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  nullable: PropTypes.bool,
};
export default ColorPickerV2;
